<template>
	<div class="results-info">
		<div class="row">
			<div class="col-8" style="text-align: left;">
				{{fileDetails.name}}
			</div>
			<div class="col-4" style="text-align: right;">
				{{fileDetails.uploadDate}}
			</div>
		</div>
		<div class="results-info-size">
			{{fileDetails.size}} MB
		</div>
		<div class="results-info-properties">
			Basic properties
		</div>
		<div class="d-flex">
			<div class="results-info-hash-name">
				MD5
			</div>
			<div class="results-info-hash">
				{{fileDetails.MD5}}
			</div>
		</div>
		<div class="d-flex">
			<div class="results-info-hash-name">
				SHA-1
			</div>
			<div class="results-info-hash">
				{{fileDetails.SHA1}}
			</div>
		</div>
		<div class="d-flex">
			<div class="results-info-hash-name mb-0">
				SHA-256
			</div>
			<div class="results-info-hash">
				{{fileDetails.SHA256}}
			</div>
		</div>
	</div>
</template>

<script>
export default {    
	name: 'Info',
	props: [
		'fileDetails'
	]
}
</script>